export const hasPermission = (user, permissionKey) => {
  if (!user || !user.permissions) return false;
  return parseInt(user.permissions[permissionKey]) === 1;
};
